import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

export const CrossSaleContainer = styled.div`
  button {
    --button-color: ${({ theme }) => theme.colors.baseColors.grey150};
  }
`;

export const CrossSaleMenuItem = styled.button`
  cursor: pointer;
  padding: 8px 16px;
  display: flex;
  gap: 1.6rem;
  align-items: center;
  border: none;
  background: none;
  font-family: inherit;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.baseColors.grey150};

  .menuItemIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    background-color: ${({ theme }) => theme.colors.baseColors.grey5};
    border-radius: 4px;
  }

  .menuItemText {
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 2rem;
    font-size: ${FontSizes.normal};
    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.namedColors.primary};
    }

    &:active {
      color: ${({ theme }) => theme.colors.namedColors.primarySelected};
    }
  }
`;

export const CrossSaleMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
